var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data d-flex flex-column justify-content-center align-items-center"},[_c('p',{staticClass:"d-title mb-1 text-center"},[_vm._v("This product is not in your inventory list")])])
}]

export { render, staticRenderFns }